import React, { Component } from 'react';
import axios from 'axios';
import { connect } from 'react-redux';
import { Row, Col, Button, Form, Input, DatePicker, Radio, InputNumber, TimePicker, message } from 'antd';
import 'antd/dist/antd.css';
import '../App.css'
import SearchBar from './SearchBar'
import { geocodeByAddress } from 'react-places-autocomplete';
import { Offline, Online } from "react-detect-offline";
import moment from 'moment';

const { compose, withProps, lifecycle } = require("recompose");
const {
  withScriptjs,
  withGoogleMap,
  GoogleMap,
  DirectionsRenderer,
} = require("react-google-maps");

const API_HOST_URL = process.env.REACT_APP_API_URL

const MapLoader = compose(
  withProps({
    googleMapURL: "https://maps.googleapis.com/maps/api/js?key=AIzaSyCZ-lrgcyu8rNUArDpZuWSEPVoLBBNt2zE&v=3.exp&libraries=geometry,drawing,places",
    loadingElement: <div style={{ height: `100%` }} />,
    containerElement: <div style={{ height: `400px` }} />,
    mapElement: <div style={{ height: `100%` }} />,
  }),
  withScriptjs,
  withGoogleMap,

  lifecycle({
    componentDidUpdate() {
      // console.log("map props:",this.props.location)

      const DirectionsService = new window.google.maps.DirectionsService();
      // const{origin_lat, origin_lng, destination_lat, destination_lng} = this.props;
      // console.log("origin_lat", from_latitude);
      // console.log("origin_lng", from_longitude);
      // console.log("destination_lat", to_latitude);
      // console.log("destination_lng",to_longitude);

      DirectionsService.route({
        origin: {lat: this.props.location.from_latitude, lng: this.props.location.from_longitude},//new google.maps.LatLng(41.8507300, -87.6512600),
        destination: {lat: this.props.location.to_latitude, lng: this.props.location.to_longitude },//new google.maps.LatLng(41.8525800, -87.6514100),
        travelMode: window.google.maps.TravelMode.DRIVING,
      }, (result, status) => {
        if (status === window.google.maps.DirectionsStatus.OK) {
          this.setState({
            directions: result,
          });
        } else {
          console.error(`error fetching directions ${result}`);
        }
      });
    }
  })
)(props =>
  <GoogleMap
    defaultZoom={7}
    defaultCenter={{lat: 0.347596, lng: 32.582520}}//{new google.maps.LatLng(41.8507300, -87.6512600)}
  >
    {props.directions && <DirectionsRenderer directions={props.directions} />}
  </GoogleMap>
);

class PostTripForm extends Component {

    state = {
          from_address: '',
          from_errorMessage: '',
          from_latitude: null,
          from_longitude: null,
          from_isGeocoding: false,

          to_address: '',
          to_errorMessage: '',
          to_latitude: null,
          to_longitude: null,
          to_isGeocoding: false,

          originCity: null,
          destinationCity: null,

          load_map: true, //to ensure map is not flickering when location is being typed 
          numberOfSeats: 1
    };

    
    onChange(date, dateString) {
        console.log(date, dateString);
      }

    handleSubmit = (e) => {
        // this.props.history.push('/find-ride');
          console.log(this.state.fromValue, this.state.toValue)
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            // this.redirectIfNotLoggedIn()
            
          if (!err) {
            // this.props.history.push('/');
              if(this.props.isAuthenticated){
            return axios.post(`${API_HOST_URL}/api/trips/`, {
                originLatitude: this.state.from_latitude,
                originLongitude: this.state.from_longitude,
                destinationLatitude: this.state.to_latitude,
                destinationLongitude: this.state.to_longitude,
                originCity: this.state.originCity,
                destinationCity: this.state.destinationCity,

                departureDate: values.departureDate,
                departureTime: moment(values.departureTime, "HH:mm").format("HH:mm"),
                numberOfSeats: this.state.numberOfSeats,
                pricePerSeat: values.pricePerSeat,
                tripDescription: values.tripDescription,

                user: this.props.loggedInUser.pk
              })
              .then(res => {
                console.log(res)
                this.props.history.push({
                  pathname: `/trip-detail-for-driver/${res.data.id}`,
                  state: {
                    showSuccessMessage: true
                  }
                });
                this.props.form.resetFields();
                this.setState({ 
                    from_latitude: null,
                    from_longitude: null,
                    to_latitude: null,
                    to_longitude: null,
                    numberOfSeats: 1
                 });

          })
              .catch(error => {
                message.error("Error occured. Trip not saved!");  
                console.log(error);

              });
            } else { 
                // this.props.history.push('/find-ride');
                // return <Redirect to="/login"/>
                console.log("props before post trip - redirect: ", this.props)
                // return this.redirectIfNotLoggedIn()
            }
          }
        });
        // this.props.history.push('/');
      }

    // redirectIfNotLoggedIn(){
    //     return (
    //         this.props.history.push('/')
    //     );
    // }

    //   Map from operations
    from_handleChange = from_address => {
        this.setState({
          from_address,
        });
      };
    
    from_handleSelect = selected => {
        this.setState({ from_address: selected });
        geocodeByAddress(selected)
        .then(response => {
          console.log("origin geocodeByAddress result: ", response[0])
          
          //latitude and longitude
          const latitude = response[0].geometry.location.lat()
          const longitude = response[0].geometry.location.lng()
          console.log("origin geometry lat lng: ", latitude, longitude)
          
          this.setState({
            from_latitude: latitude,
            from_longitude: longitude,
          });

          console.log("the type of coordinate:", typeof latitude, typeof this.state.from_latitude)

          //city address
          const address_components = response[0].address_components;
                for(let i = 0; i < address_components.length; i++ ){
                  if(address_components[i].types.indexOf("locality") != -1 && address_components[i].types.indexOf("political") != -1){
                    console.log("origin city: ", address_components[i].long_name)
                    this.setState({
                      originCity: address_components[i].long_name
                    });
                  }
                }
        })
        .catch(error => {
          console.log('error', error); // eslint-disable-line no-console
        });
      };

    from_handleCloseClick = () => {
        this.setState({
          from_address: '',
          from_latitude: null,
          from_longitude: null,
        });
      };

    //   Map from operations
    to_handleChange = to_address => {
        this.setState({
          to_address,
        });
      };
    
      to_handleSelect = selected => {
        this.setState({ to_address: selected });
        geocodeByAddress(selected)
        .then(response => {
          console.log("destination geocodeByAddress result: ", response[0])
          
          //latitude and longitude
          const latitude = response[0].geometry.location.lat()
          const longitude = response[0].geometry.location.lng()
          console.log("destination geometry lat lng: ", latitude, longitude)
          
          this.setState({
            to_latitude: latitude,
            to_longitude: longitude,
          });

          //city address
          const address_components = response[0].address_components;
                for(let i = 0; i < address_components.length; i++ ){
                  if(address_components[i].types.indexOf("locality") != -1 && address_components[i].types.indexOf("political") != -1){
                    console.log("destination city: ", address_components[i].long_name)
                    this.setState({
                      destinationCity: address_components[i].long_name
                    });
                  }
                }
        })
        .catch(error => {
          console.log('error', error); // eslint-disable-line no-console
        });
      };

    to_handleCloseClick = () => {
        this.setState({
          to_address: '',
          to_latitude: null,
          to_longitude: null,
        });
      };

      handleNumberOfSeatsChange = (e) => {
        this.setState({
            numberOfSeats: e.target.value
        });
    }
    
 
    render() {
        const { getFieldDecorator } = this.props.form;
        const { TextArea } = Input;
        const { from_latitude, from_longitude, to_latitude, to_longitude } = this.state;


    return (
        
        <div>
            <div style={{ background: '#00abff'}}>
                <Row>
                    <Col md={{span: 24}}>
                        <h1 style={{color: "#ffffff", margin: "12px", textAlign: 'center', fontWeight: 'bold'}}>Post a trip</h1>
                    </Col>
                </Row>
            </div>
            <div style={{ padding: 24}}>
                <br/>
                <Form onSubmit={this.handleSubmit}>
                    <Row>
                        <Col md={{span:8, offset:4}}>

                            <h4 style={{fontWeight: 'normal'}}>Coming From:</h4>
                            <SearchBar 
                            inputIconStyle="icon_from"
                            handleChange={this.from_handleChange}
                            address={this.state.from_address}
                            handleSelect={this.from_handleSelect}
                            placeholder='Enter an Origin.' 
                            handleCloseClick={this.from_handleCloseClick} 
                            showCloseIcon={this.state.from_latitude != null && this.state.from_longitude != null }/>
                            <br/>

                            <h4 style={{fontWeight: 'normal'}}>Going To:</h4>
                            <SearchBar
                            inputIconStyle="icon_to" 
                            handleChange={this.to_handleChange}
                            address={this.state.to_address}
                            handleSelect={this.to_handleSelect}
                            placeholder='Enter a destination.' 
                            handleCloseClick={this.to_handleCloseClick}  
                            showCloseIcon={this.state.to_latitude != null && this.state.to_longitude != null }/>
                            <br/>

                            <Form.Item
                                // {...formItemLayout}
                                label="When are you Leaving ?"
                                style={{ display: 'inline-block'}}
                                >
                                {getFieldDecorator('departureDate', 
                                {
                                    rules: [{ type: 'object', required: true, message: 'Please select date!' }],
                                })(
                                    <DatePicker  />
                                )}
                            </Form.Item>
                            <span style={{ display: 'inline-block', width: '24px', textAlign: 'center' }}>
                              &nbsp;
                            </span>
                            <Form.Item
                                // {...formItemLayout}
                                label="Time"
                                style={{ display: 'inline-block'}}
                                >
                                {getFieldDecorator('departureTime', {
                                    rules: [{ type: 'object', required: true, message: 'Please select time!' }],
                                })(
                                    <TimePicker use12Hours  format="hh:mm A" />
                                )}
                            </Form.Item>

                            <Form.Item
                                label="How many seats do you have?"
                                // {...formItemLayout}
                            >
                                <Radio.Group defaultValue="1" onChange={this.handleNumberOfSeatsChange}>
                                <Radio.Button value="1">1</Radio.Button>
                                <Radio.Button value="2">2</Radio.Button>
                                <Radio.Button value="3">3</Radio.Button>
                                <Radio.Button value="4">4</Radio.Button>
                                <Radio.Button value="5">5</Radio.Button>
                                <Radio.Button value="6">6</Radio.Button>
                                <Radio.Button value="7">7</Radio.Button>
                                </Radio.Group>
                            </Form.Item>

                            <Form.Item
                                // {...formItemLayout}
                                label="Price Per Seat (Shs)"
                                >
                                {getFieldDecorator('pricePerSeat', { initialValue: 0})(
                                    <InputNumber min={1} max={100000} />
                                )}
                                {/* <span style={{fontStyle: 'italic'}} className="ant-form-text"> Recommended Price : 0</span> */}
                            </Form.Item>

                            <Form.Item
                                label="Describe your trip:"
                                // labelCol={{ span: 5 }}
                                // wrapperCol={{ span: 12 }}
                                >
                                {getFieldDecorator('tripDescription', {
                                    rules: [{ required: true, message: 'Please enter some description about your trip' }],
                                })(
                                    <TextArea rows={4}  placeholder="Include your pick-up and drop-off points, which route you are taking, etc" />
                                )}
                            </Form.Item>

                            <Form.Item
                                // wrapperCol={{ span: 12, offset: 5 }}
                                >
                                <Button type="primary" htmlType="submit" style={{height: '3em', marginRight: '10px', width: '100%', backgroundColor: '#ff3d00', borderWidth: '0px'}}>
                                    Post Trip
                                </Button>
                            </Form.Item>
                        </Col>
                        
                        <Col md={{span:8, offset:1}} >
                            {/* <MapLoader 
                                origin_lat={this.state.from_latitude}
                                origin_lng={this.state.from_longitude}
                                destination_lat={this.state.to_latitude}
                                destination_lng={this.state.to_longitude}
                            /> */}
                            { 
                              <div>
                                <Online>
                                    <MapLoader location={{ from_latitude: from_latitude, from_longitude: from_longitude, to_latitude: to_latitude, to_longitude: to_longitude }}/>
                                </Online>
                                <Offline>You are not connected to the internet. Connect to the internet to see the maps!</Offline>
                              </div>
                            }
                        </Col>
                    </Row>  
            </Form>

            </div> 
        </div>
    );
  }
}

const mapStateToProps = (state) => {
    return {
        isAuthenticated: state.token !== null,
        loggedInUser: state.currentUser
    }
}

const PostTrip = Form.create({ name: 'post-trip-form' })(PostTripForm);

export default connect(mapStateToProps, null)(PostTrip);


